import { createFileRoute } from '@tanstack/react-router'

import { UserLogs } from '@/pages/UserLogs'
import { userLogsSearchSchema } from '@/pages/UserLogs/userLogsSearchSchema'

export const Route = createFileRoute('/_app/logs/user')({
  component: UserLogs,
  validateSearch: userLogsSearchSchema,
})
